/*! @pentacode/ui v0.1.0 */
// src/elements/table/table-scroll.ts
var e = class {
	constructor(e) {
		this.scrollbarWidth = 0, this.scrollbarHeight = 0, this._thead = null, this._scroller = null, this._resizeObserver = null, this._resizeRaf = 0, this._syncHeaderScroll = () => {
			this._thead && this._scroller && !this.host.native && (this._thead.scrollLeft = this._scroller.scrollLeft), this.updateShadows();
		}, this.host = e, e.addController(this);
	}
	hostConnected() {
		this.host.hasUpdated && this.initElements();
	}
	hostUpdated() {
		requestAnimationFrame(() => {
			this._rebindScroller(), this.updateShadows();
		});
	}
	initElements() {
		this._rebindScroller(), this._resizeObserver ??= new ResizeObserver(() => {
			this._resizeRaf ||= requestAnimationFrame(() => {
				this._resizeRaf = 0, this._measureScrollbar(), this.updateShadows();
			});
		}), this._scroller && this._resizeObserver.observe(this._scroller);
	}
	hostDisconnected() {
		this._scroller?.removeEventListener("scroll", this._syncHeaderScroll), this._resizeObserver?.disconnect(), this._resizeObserver = null, this._resizeRaf && cancelAnimationFrame(this._resizeRaf), this._resizeRaf = 0, this._thead = null, this._scroller = null;
	}
	_rebindScroller() {
		let e = this.host.native ? this.host.renderRoot.querySelector(".native-scroller") : this.host.renderRoot.querySelector("tbody");
		e === this._scroller ? this._thead = this.host.renderRoot.querySelector("thead") : (this._scroller?.removeEventListener("scroll", this._syncHeaderScroll), this._resizeObserver?.disconnect(), this._scroller = e, this._thead = this.host.renderRoot.querySelector("thead"), this._scroller?.addEventListener("scroll", this._syncHeaderScroll), this._resizeObserver && this._scroller && this._resizeObserver.observe(this._scroller));
	}
	updateShadows() {
		if (!this._scroller) return;
		if (!this.host.scrollShadows) {
			this.host.toggleAttribute("pinned-left-shadow", !1), this.host.toggleAttribute("pinned-right-shadow", !1), this.host.toggleAttribute("scroll-top-shadow", !1), this.host.toggleAttribute("scroll-bottom-shadow", !1);
			return;
		}
		let { scrollLeft: e, scrollWidth: t, clientWidth: n, scrollTop: r, scrollHeight: i, clientHeight: a } = this._scroller, o = t - n, s = i - a;
		this.host.toggleAttribute("pinned-left-shadow", e > 1), this.host.toggleAttribute("pinned-right-shadow", o - e > 1), this.host.toggleAttribute("scroll-top-shadow", r > 1), this.host.toggleAttribute("scroll-bottom-shadow", s - r > 1);
	}
	_measureScrollbar() {
		if (!this._scroller) return;
		let e = this._scroller.offsetWidth - this._scroller.clientWidth, t = this._scroller.offsetHeight - this._scroller.clientHeight, n = !1;
		if (e !== this.scrollbarWidth && (this.scrollbarWidth = e, this.host.style.setProperty("--_scrollbar-header-overflow", e > 0 ? "scroll" : "auto"), n = !0), t !== this.scrollbarHeight && (this.scrollbarHeight = t, n = !0), n) {
			let n = this.host.style;
			n.setProperty("--_scrollbar-width", `${e}px`), n.setProperty("--_scrollbar-height", `${t}px`), n.setProperty("--_scrollbar-size", `${Math.max(e, t)}px`);
			let r = t > 0, i = e > 0;
			r ? n.setProperty("--_scroll-shadow-bottom-left-radius", "0") : n.removeProperty("--_scroll-shadow-bottom-left-radius"), r || i ? n.setProperty("--_scroll-shadow-bottom-right-radius", "0") : n.removeProperty("--_scroll-shadow-bottom-right-radius"), this.host.requestUpdate();
		}
	}
};
export { e as ScrollController };

//# sourceMappingURL=table-scroll.js.map